module.exports = __webpack_public_path__ + "static/media/bigu.8c1d9f72.ico";